import clsx from "clsx";
import { Col, Form, Pagination, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import React from "react";
import _ from "lodash";
import EmptyItemView from "../EmptyItemView";
import * as eWithdrawSelectors from "../../selectors/e-withdraw.js";
import constants from "../../constants";
import LoadingOverlay from "../LoadingOverlay";
import * as userSelectors from "../../selectors/user";
import * as setOffSelectors from "../../selectors/set-off";
import {getSubmittedTransactionDate, getSubmittedTransactionDateTime} from "../../selectors/set-off";
import {getEWithdrawCurrencySymbolText} from "../../selectors/e-withdraw.js";

const CustomEWithdrawHistory = ({
  data,
  page,
  setPage,
  onClickViewPayment,
  statusOptions,
  onChangeStatus,
  statusFilter,
  onChangeDateFrom,
  dateTo,
  dateFrom,
  onChangeDateTo,
  onClickDeleteFunction,
  loading
}) => {
  const datalisting = _.get(data, ["data", "data"], []);
  // const loading = _.get(data, ["isLoading"], false);
  const lastPage = _.get(data, ["data", "meta", "last_page"], null);
  const onClickView = (values, id) => {
    onClickViewPayment(values, id);
  };
  const onClickDelete = (url) => {
    onClickDeleteFunction(url);
  };
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];

  return (
    <div className=" mt-4 py-3">
      <div className={clsx("custom-table-info-container padding-12px")}>
        <Row>
          <Col xl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel">Status</Form.Label>
              <Form.Select
                className="formControl"
                style={{ height: "100%" }}
                onChange={onChangeStatus}
                value={statusFilter}
              >
                <option value={null}>All</option>
                {_.map(statusOptions, (item, index) => (
                  <option key={index} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel">Date From</Form.Label>
              <Form.Control
                min="2025-04-01"
                max={dateNow}
                onChange={onChangeDateFrom}
                value={dateFrom}
                className="formControl"
                name="date_from"
                type="date"
              />
            </Form.Group>
          </Col>
          <Col xl={2} lg={3} md={4} sm={6} xs={12}>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel">Date To</Form.Label>
              <Form.Control
                max={dateNow}
                min={dateFrom}
                onChange={onChangeDateTo}
                value={dateTo}
                className="formControl"
                name="date_to"
                type="date"
              />
            </Form.Group>
          </Col>
        </Row>

        <div className={"responsive-table-border table-w-1400 mt-3"}>
          <Table responsive="lg">
            <thead>
            <tr className={"custom-table-setoff-styled"}>
              <th style={{minWidth: 100}}>Date/Time</th>
              <th style={{minWidth: 100}}>Client Code</th>
              <th style={{minWidth: 120}}>Currency Code</th>
              <th style={{minWidth: 120}}>Transaction Amount</th>
              <th style={{minWidth: 100}}>Status</th>
              <th style={{minWidth: 150}}>Action</th>
            </tr>
            </thead>
            <tbody>
              {!_.isEmpty(datalisting) ? (
                _.map(datalisting, (item, index) => {
                  const action = eWithdrawSelectors.getEWithdrawActionText(item);
                  const status = eWithdrawSelectors.getEWithdrawStatusText(item);
                  const statusValue = eWithdrawSelectors.getEWithdrawStatusValue(item);
                  const currencyCountry = eWithdrawSelectors.getEWithdrawCurrencySymbolText(item);
                  const clientCode = eWithdrawSelectors.getEWithdrawClientCode(item);
                  const amount = eWithdrawSelectors.getEWithdrawAmountFullText(item);
                  const isCancellable = setOffSelectors.getSubmittedContractIsCancellable(item);
                  const cancelLink = setOffSelectors.getSubmittedContractCancelLink(item);
                  const transactionDate = setOffSelectors.getSubmittedTransactionDateTime(item);

                  // Status color turnover
                  return (
                    <tr key={index}>
                      <td>{transactionDate}</td>
                      <td>{clientCode}</td>
                      <td>{currencyCountry}</td>
                      <td>{amount}</td>
                      <td>
                        <span
                          className={clsx("status-span", {
                            ["pending-color"]: statusValue === constants.STATUS_SUBMITTED ||statusValue === constants.STATUS_PENDING,
                            ["successful-color"]:
                              statusValue === constants.STATUS_FILLED,
                            ["error-color"]:
                              statusValue === constants.STATUS_ERROR ||
                              statusValue === constants.STATUS_EXPIRED ||
                              statusValue === constants.STATUS_CANCELLED,
                          })}
                        >
                          {status}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex">
                          <button
                            className={clsx("btn custom-button-grey me-2")}
                            onClick={() => onClickView(item)}
                          >
                            View
                          </button>
                          {isCancellable ? (
                              <button
                                  className={clsx("btn custom-button-white small long mx-2")}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onClickDelete(cancelLink)
                                  }}
                                  disabled={!isCancellable}
                              >
                                Cancel
                              </button>
                          ) : ( false )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6}>
                    <EmptyItemView />
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot className="epayment-table-footer">
              <tr>
                <td colSpan={7}>
                  {lastPage > 1 ? (
                    <div className={clsx("d-flex justify-content-center")}>
                      <Pagination
                        className="mt-2"
                        onClick={(e) => {
                          if (_.toInteger(e.target.text) !== 0 && _.toInteger(e.target.text) !== page) {
                            setPage(_.toInteger(e.target.text));
                          }
                        }}
                      >
                        {_.times(lastPage, (index) => {
                          return (
                            <Pagination.Item key={index + 1} active={page === index + 1}>
                              {index + 1}
                            </Pagination.Item>
                          );
                        })}
                      </Pagination>
                    </div>
                  ) : (
                    false
                  )}
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>
      </div>
      <LoadingOverlay loading={loading}></LoadingOverlay>
    </div>
  );
};

export default CustomEWithdrawHistory;
